import { useNavigate } from 'react-router-dom'
import { getEventIdWithoutTimestamp, isValidHttpUrl } from '../../../../Utils/helpers'
import Attendees from '../Relevant Cards/Attendees'
import Relevant from '../Relevant Cards/Relevant'
import Insights from '../Relevant Cards/Insights'
import { useState } from 'react'
let _ = require('lodash')

const { Flex, Text, Image, Box, Button, Switch, Tooltip } = require('@chakra-ui/react')

export const formatAttendeesText = (attendees) => {
  let returnString = ''
  if (attendees.length > 0) {
    returnString = attendees[0]
  }

  if (attendees.length > 1) {
    returnString = `${returnString}, ${attendees[1]}`
  }

  if (attendees.length === 3) {
    returnString = `${returnString} and 1 other`
  } else if (attendees.length > 3) {
    returnString = `${returnString} and ${attendees.length - 2} others`
  }

  return returnString
}

const ExpandedMeeting = ({meeting, index, changeAllowBotState, handleDetailsClick, user}) => {
  const navigate = useNavigate()

  const [botStateChanged, setBotStateChanged] = useState(false)

  const getTooltipText = () => {
    if (botStateChanged && user && user.name) {
      return `Bot disabled by ${ _.startCase(_.toLower(user.name))}. Take notes manually.`
    } else if (meeting.bot_join_updated_by_user) {
      return `Bot disabled by ${ _.startCase(_.toLower(meeting.bot_join_updated_by_user))}. Take notes manually.`
    }

    return 'Bot currently only available for Gmeet'
  }

  const renderRelevantCard = () => {
    if (!meeting.isUpcoming && meeting.insight_count) {
      return <Insights meeting={meeting} />
    }

    if (meeting.previous_event_id || meeting.reccuring_previous_event_id) {
      return <Relevant meeting={meeting} />
    }

    return (
      <Attendees meeting={meeting} />
    )
  }

  const renderOpenLink = (link) => {
    if (!link || isValidHttpUrl(link) === false) {
      return <>No Link</>
    }
    if (link?.includes('meet.google.com')) {
      return (
        <>
          <Image mr={1} mt='1px' h={3} color='brandTextBlack' src='/assets/icons/meetLink.png' />
          Join Google Meet
        </>
      )
    }
    if (link?.includes('zoom.us')) {
      return (
        <>
          <Image mr={1} mt='1px' h={3} width='20px' height='15px' color='brandTextBlack' src='/assets/icons/zoomLink.png' />
          Join Zoom
        </>
      )
    }
    if (link?.includes('teams.microsoft.com')) {
      return (
        <>
          <Image mr={1} mt='1px' h={3} width='20px' height='15px' color='brandTextBlack' src='/assets/icons/teamsLink.png' />
          Join Teams
        </>
      )
    }
    return (
      <>
      Join Meeting
      </>
    )
  }

  return (
    <Flex position='relative' mt={index == 0 ? 0 : 2} mb='28px' h='258px'>
      <Box position='absolute' bg='brandBackground' h='4px' w='full' top='-12px' />
      <Flex
        flexDirection='column'
        border='0.5px solid rgba(28, 28, 28, 0.1)'
        boxShadow='0px 13px 5px rgba(0, 0, 0, 0.01), 0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
        borderRadius='12px'
        bg='white'
        p={5}
        flex='59'
      >
        <Flex alignItems='center'>
          <Text color='#654F6F' fontWeight='800' fontSize='12px'>
            {meeting.isUpcoming ? 'UPCOMING' : 'PREVIOUS'}
          </Text>

          <Box ml='auto' />
          
          {!meeting.allowBot && (
            <Tooltip 
              p={2}
              borderRadius='8px' bg='#222222' fontSize='14px' color='#E2E2E2' 
              label={getTooltipText()}
            >
              <Image mr='8px' boxSize={5} color='brandTextBlack' src='/assets/icons/alert.svg' />
            </Tooltip>
          )}
          {meeting.isUpcoming && (
            <Flex
              bg='#F3F3F3'
              borderRadius='full'
              py='6px'
              px={2}
            >
              <Image mr='6px' boxSize={5} color='brandTextBlack' src='/assets/icons/robot.svg' />
              <Switch disabled={!meeting.link?.includes('meet.google.com')} isChecked={meeting.allowBot} onChange={() =>{
                changeAllowBotState(!meeting.allowBot) 
                setBotStateChanged(true)
              }} colorScheme='brandPurple' />
            </Flex>
          )}
        </Flex>

        {meeting.isUpcoming ? (
          <>
            <Flex mt='auto' alignItems='center'>
              <Text color='brandTextBlack' fontWeight='700' fontSize='24px'
                cursor='pointer'
                onClick={() => navigate(`/transcripts-summaries/summary?eventId=${meeting.eventId}&tab=HIGH&eventName=${meeting.title}`)}
              >
                {meeting.title}
              </Text>
              {meeting.isRecurring  && (
                <Image cursor='pointer' ml='15px' mt={1} boxSize={4} color='brandTextBlack' src='/assets/icons/recurringEvent.svg'
                  onClick={() => {
                    navigate(`/transcripts-summaries/dashboard?name=rec_${getEventIdWithoutTimestamp(meeting.eventId)}___${meeting.title.replaceAll(
                      ' ',
                      '-'
                    )}`)
                  }}
                />
              )}
            </Flex>
          </>
        ) : (
          <>
            <Flex mt={4} alignItems='center'>
              <Text color='brandTextBlack' fontWeight='700' fontSize='24px'
                cursor='pointer'
                onClick={() => navigate(`/transcripts-summaries/summary?eventId=${meeting.eventId}&tab=HIGH&eventName=${meeting.title}`)}
              >
                {meeting.title}
              </Text>
              {meeting.isRecurring  && (
                <Image cursor='pointer' ml='15px' mt={1} boxSize={4} color='brandTextBlack' src='/assets/icons/recurringEvent.svg'
                  onClick={() => {
                    navigate(`/transcripts-summaries/dashboard?name=rec_${getEventIdWithoutTimestamp(meeting.eventId)}___${meeting.title.replaceAll(
                      ' ',
                      '-'
                    )}`)
                  }}
                />
              )}
            </Flex>

            <Flex mt='8px' alignItems='center'>
              {meeting.tags && meeting.tags.map(({color, name: tag, id}, index) => (
                <Flex ml={index === 0 ? 0 : 5} key={`expanded-${meeting.eventId}-${tag}-${index}`} alignItems='center'>
                  <Box mt={1} boxSize={3} bg={color ?? '#4E60E2'} borderRadius='full' />
                  <Text
                    color='brandTextGrey2'
                    flex={1}
                    ml={2.5}
                    lineHeight='21.6px'
                    noOfLines={1}
                    wordBreak='break-all'
                    cursor='pointer'
                    onClick={() => {
                      navigate(`/transcripts-summaries/dashboard?name=tag_${id.split('-')[1]}___${tag.replaceAll(
                        ' ',
                        '-'
                      )}`)
                    }}
                  >
                    {tag}
                  </Text>
                </Flex>
              ))}

              {meeting.tags && meeting.tags.length ? <Box ml={5} /> : <></>}

              {meeting.functions && meeting.functions.map(({function: f}, index) => (
                <Flex  ml={index === 0 ? 0 : 5} key={`expanded-${meeting.eventId}-${f}-${index}`}>
                  <Text
                    color='brandTextGrey2'
                    flex={1}
                    lineHeight='21.6px'
                    noOfLines={1}
                    wordBreak='break-all'
                    cursor='pointer'
                    onClick={() => {
                      navigate(`/transcripts-summaries/dashboard?name=function_${f.replaceAll(
                        ' ',
                        '-'
                      )}`)
                    }}
                  >
                    {f}
                  </Text>
                </Flex>
              ))}
            </Flex>

            <Text flex={1} color='#222222' fontWeight='500' mt={4} noOfLines={2}>
              {meeting.summary}
            </Text>
          </>
        )}

        <Flex mt='19px'>
          <Button
            colorScheme='brandWhite'
            fontSize='14px'
            px={3}
            py={2}
            borderRadius='56px'
            border='0.5px solid rgba(34, 34, 34, 0.2)'
            h='auto'
            color='brandTextBlack'
            onClick={() => handleDetailsClick()}
            isDisabled={
              !meeting?.link || isValidHttpUrl(meeting?.link) === false
            }
          >
            {meeting.isUpcoming ? (
              <>
                {renderOpenLink(meeting.link)}
              </>
            ): (
              <>
                View Details
                <Image ml={2} mt='1px' boxSize={2.5} color='brandTextBlack' src='/assets/icons/arrowRight.svg' />
              </>
            )}
          </Button>

          <Flex alignItems='center' ml='22px'>
            <Image mr={2} mt='2px' boxSize={3} color='brandTextBlack' src='/assets/icons/people.svg' />
            <Text
              fontSize='14px'
              color='brandTextBlack'
              fontWeight='500'
            >
              {formatAttendeesText(meeting.attendees)}
            </Text>
          </Flex>


        </Flex>
      </Flex>

      <Flex flex='31' flexDirection='column' ml={2.5} gap={2.5}>
        <Flex
          flexDirection='column'
          border='0.5px solid rgba(28, 28, 28, 0.1)'
          boxShadow='0px 13px 5px rgba(0, 0, 0, 0.01), 0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
          borderRadius='12px'
          bg='white'
          p={5}
          flex={1}
          maxH='130px'
        >
          <Flex alignItems='center'>
            <Text color='#659157' fontWeight='800' fontSize='12px'>
              WHEN
            </Text>
          </Flex>

          <Flex mt={3} alignItems='center'>
            <Text color='brandTextBlack' fontWeight='700' fontSize='24px'>
              {meeting.time}
            </Text>
          </Flex>
          
          <Flex mt='4px'>
            <Text
              color='brandTextGrey2'
              flex={1}
              lineHeight='21.6px'
              noOfLines={1}
              wordBreak='break-all'
            >
              {meeting.meetingDay}
            </Text>
          </Flex>

        </Flex>

        {renderRelevantCard()}
        
      </Flex>
    </Flex>
  )
}

export default ExpandedMeeting